import React, { useState } from 'react';
import { Button, Header, Icon, Image, Menu, Modal } from "semantic-ui-react";

const ArgoHeader = () => {
    const [showAboutDialog, setShowAboutDialog] = useState(false);
    return (
        <Menu className='navy' stackabble='true' >
        <Menu.Item>
            <Image
                size='tiny'
                src='./argologo.png'
                as='a'
                href='http://argodevelopmentstudio.com'
                target='_blank' />
        </Menu.Item>
        <Menu.Menu position='right'>
            <Menu.Item  className='white' href='//argodevelopmentstudio.com/contact/'>
                <Icon name='address card' />
                Contact
            </Menu.Item>            
            <Modal trigger={<Menu.Item name='about' className='white' onClick={() => setShowAboutDialog(true)}><Icon name='info circle' />Info</Menu.Item>}
                    centered={false}
                    open={showAboutDialog}
                    onClose={() => setShowAboutDialog(false)}
                    size='tiny'>
                <Header icon='info' content='About' />
                <Modal.Content>
                    <p>
                    The ARGO App is a unique Cost to Build calculator that calculates the approximate construction costs
                    and associated professional fees for a variety of build types in a total of 24 countries in the
                    Caribbean and in Ireland.
                    </p>
                    <p>
                    It is based on data that ARGO has collected from its experience in these countries and informed by
                    market trend research. Indicative building costs are given as a range from low to high to allow for
                    cost variation influenced by project complexity, internal and external material selection and finish
                    quality. The mid-point of this range will be a reasonable approximation of your construction costs, 
                    but since every project is unique we recommend you contact ARGO for additional guidance to help 
                    ensure project success.
                    </p>
                    <p>
                    The apps calculations are based on the building’s footprint only and should be used as a guide for
                    budgeting purposes. The calculations will not include external works, most of which are site
                    specific costs, including infrastructure, landscaping and amenities.
                    </p>
                    <p>
                    During market testing, the app achieved a margin of error of less than 10%.
                    </p>
                    <p>
                    The cost of other professional services that may be required for your special project (e.g.  
                    environmental impact assessments, landscaping design, land surveying, legal expenses etc.) are not
                    allowed for in these cost estimates.
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button className='navy' onClick={() => setShowAboutDialog(false)}>OK</Button>
                </Modal.Actions>
            </Modal>
        </Menu.Menu>
        </Menu>
    );
};
export default ArgoHeader;